<template>
    <div class="row">

        <div class="col-12">
            <form class="forms-sample" @submit.prevent="updateAccountData">

                <div class="form-group">
                    <label for="first_name" class="font-weight-bolder">{{ $t("user.first_name") }}</label>
                    <input type="text" class="form-control" id="first_name" :placeholder="$t('user.first_name')"  v-model="user.first_name"
                           :class="{'is-invalid': $errors.has('first_name')}">
                    <error input="first_name"/>
                </div>

                <div class="form-group">
                    <label for="last_name" class="font-weight-bolder">{{ $t("user.last_name") }}</label>
                    <input type="text" class="form-control" id="last_name" :placeholder="$t('user.last_name')"  v-model="user.last_name"
                           :class="{'is-invalid': $errors.has('last_name')}">
                    <error input="last_name"/>
                </div>

                <div class="form-group">
                    <label for="email" class="font-weight-bolder">{{ $t("user.email") }}</label>
                    <input type="email" class="form-control" id="email" :placeholder="$t('user.email')"  v-model="user.email"
                            :class="{'is-invalid': $errors.has('email')}">
                    <error input="email"/>
                </div>

                <div class="form-group">
                    <label for="preferred_language" class="font-weight-bolder">{{ $t("user.preferred_language") }}</label>
                    <select class="form-control" id="preferred_language" :placeholder="$t('user.preferred_language')"  v-model="user.preferred_language"
                            :class="{'is-invalid': $errors.has('preferred_language')}">
                        <option value="lb">
                            {{ $t('languages.luxembourgish') }}
                        </option>
                        <option value="en">
                            {{ $t('languages.english') }}
                        </option>
                        <option value="de">
                            {{ $t('languages.german') }}
                        </option>
                    </select>
                    <error input="preferred_language"/>
                </div>

                <div class="form-group">
                    <!-- Edit mode -->
                    <button class="btn btn-outline-dark">
                        {{ $t('actions.save') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AccountRepository from "../../../repositories/Account/AccountRepository";
import dayjs from "dayjs";

export default {
    name: "AccountDataViewEdit",
    data: () => ({
        user: [],
        userCopy: [],
    }),
    watch: {
        preferred_language(value) {
            this.$i18n.locale = value;
            dayjs.locale(value);
        }
    },
    methods: {
        getData() {
            AccountRepository.getData()
                .then((res) => this.user = res.data)
        },

        updateAccountData() {
            AccountRepository.update({
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                preferred_language: this.user.preferred_language,
            }).then((res) => {
                this.saved = true;
                this.editEnabled = false;
                this.$i18n.locale = this.user.preferred_language;
                this.$store.dispatch("updateUserData", res.data);
                this.$nextTick(() => {
                    this.$snotify.success(this.$t('actions.updated'));
                });
            });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style scoped>

</style>
